import { render } from "./Widget1.vue?vue&type=template&id=c2c2fdba&ts=true"
import script from "./Widget1.vue?vue&type=script&lang=ts"
export * from "./Widget1.vue?vue&type=script&lang=ts"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__